<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Testimonials</div>
            </div>
            <div class="col-md-2 offset-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="changeListOrder">Change List Order</button>
            </div>
            <div class="col-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createTestimonial">Add Testimonial</button>
            </div>
          </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="testimonials.columns" :data="testimonials.data">
                    <template slot="table-row" v-if="testimonials.data.length">
                        <tr v-for="(item, index) in testimonials.data" :key="index" :class="{'inactive': item.status === '0'}">
                          <td>{{item.pageName}}</td>
                            <td>{{item.author}}</td>
                            <td>{{item.designation}}</td>
                            <td>{{item.location}}</td>
                          <td>{{item.quote}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.isActive != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewTestimonial(item)" v-tooltip.top-center="testimonials.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editTestimonial(item)" v-tooltip.top-center="testimonials.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const testimonialColumns = ['Page', 'Author', 'designation', 'Location', 'Quote', 'Status', 'Operations'];
    export default {
        name: 'Testimonials',
        components: {
            LTable,
        },
        data() {
        return {
              testimonials: {
                tooltips: {
                    view: 'View Testimonial',
                    edit: 'Edit Testimonial',
                    delete: 'Inactivate Testimonial',
                    activate:'Activate Testimonial',
                },
                columns: [...testimonialColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchTestimonials () {
            this.$store.dispatch('FETCH_TESTIMONIALS')
                    .then((res) => {
                        this.testimonials.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        changeListOrder(){
          this.$router.push({ name: 'Testimonial Ordering'})
        },
        viewTestimonial(testimonial){
            this.$router.push({ name: 'ViewTestimonial', params: { id: testimonial.pkCarouselId}})
        },
        editTestimonial(testimonial){
            this.$router.push({ name: 'EditTestimonial', params: { id: testimonial.pkCarouselId}})
        },
        createTestimonial(){
            this.$router.push({ name: 'CreateTestimonial'})
        },
        deleteTestimonial(testimonial, boolean){
            console.log("testimonial : ", testimonial);
            this.$store.dispatch('DELETE_SELECTED_TESTIMONIAL', {testimonialId: testimonial.pkCarouselId})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchTestimonials();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        }
    },
    created() {
        this.fetchTestimonials();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Testimonials/Testimonials.vue